import styled from '@emotion/styled'
import { Stack } from '@pubstack/common/src/stack'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Icon } from '~/components/Icon'
import { Tooltip } from '~/components/Tooltip'

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`

type Props = {
  stack: Stack
}

export const StackStatus: FunctionComponent<Props> = ({ stack }) => {
  const iconName = stack.isOutOfSync ? 'sync_problem' : stack.status === 'live' ? 'check_circled' : stack.status === 'archived_group' ? 'folder' : stack.status === 'to-deploy' ? 'send' : null
  const iconFill = stack.isOutOfSync ? Colors.Warning : ['to-deploy', 'live'].includes(stack.status) ? Colors.Success : stack.status === 'archived_group' ? Colors.SlateGrey : undefined
  const label = stack.status === 'to-deploy' ? 'Ready to deploy' : stack.status === 'archived_group' ? 'Archived' : stack.status === 'live' ? 'Live' : ''
  return (
    <StatusWrapper>
      {iconName &&
        (stack.isOutOfSync ? (
          <Tooltip title="Synchronization required" css={{ height: '18px' }}>
            <Icon name={iconName} fill={iconFill} height="18px" width="18px" />
          </Tooltip>
        ) : (
          <Icon name={iconName} fill={iconFill} height="18px" width="18px" />
        ))}
      {label}
    </StatusWrapper>
  )
}
